export type InboxKind = 'system' | 'invite' | 'status' | 'message' | 'security' | 'deadline' | 'file';

export interface InboxItem {
  id: string;
  kind: InboxKind;
  title: string;
  body: string;
  ts: string;
  read: boolean;
  link?: string;
}

export const KIND_ICON: Record<InboxKind, string> = {
  system: '⚙️',
  invite: '🎉',
  status: '📋',
  message: '💬',
  security: '🔐',
  deadline: '⏰',
  file: '📎',
};

export const KIND_COLOR: Record<InboxKind, string> = {
  system: '#41d2ff',
  invite: '#49ddb7',
  status: '#ffd978',
  message: '#b39ddb',
  security: '#ef9a9a',
  deadline: '#ffb74d',
  file: '#80cbc4',
};

export const NOTIFICATIONS_CHANGED_EVENT = 'za:notifications-changed';

export function getStoredInbox(_userId?: string): InboxItem[] {
  return [];
}

export function markNotificationAsRead(_id: string, userId?: string): InboxItem[] {
  return getStoredInbox(userId);
}

export function markAllNotificationsAsRead(userId?: string): InboxItem[] {
  return getStoredInbox(userId);
}

export function dismissNotification(_id: string, userId?: string): InboxItem[] {
  return getStoredInbox(userId);
}

export function getUnreadCount(userId?: string): number {
  return getStoredInbox(userId).filter((item) => !item.read).length;
}
